import integration from './../images/onPremise.png';

const Integration = () => {
  return (
    <div>
    <p className="standard-paragraph">
    <div class="container">
    <div class="image-container">
    <img src={integration} alt="Integration" width={300}/>
    </div>
    <div class="text-container">
      <h2>Integration</h2>
      <p class="text-text">
      Elevate your infrastructure with seamless integration between AWS services and on-premise systems. Our solutions provide 
      a unified and scalable approach, enabling efficient data flow and communication. Explore our software development services,
       specializing in robust integration solutions that bridge the gap between cloud and on-premise environments, 
       fostering a cohesive and interconnected IT ecosystem.
      </p>
    </div>
  </div>

    <ul class="custom-list">
    <li><strong>AWS Direct Connect:</strong> Establish a dedicated network connection from on-premises to AWS for secure, low-latency data transfer.</li>
    <li><strong>VPC Peering:</strong> Set up Virtual Private Cloud (VPC) peering to connect VPCs in different regions or AWS accounts securely.</li>
    <li><strong>Amazon S3 Cross-Region Replication:</strong> Replicate data between different AWS regions for redundancy and data distribution.</li>
    <li><strong>AWS Lambda for Serverless Integration:</strong> Create Lambda functions for serverless integration between services and applications.</li>
    <li><strong>Amazon API Gateway:</strong> Use API Gateway to create, publish, and manage APIs, enabling external systems to interact with AWS services.</li>
    <li><strong>Amazon App Runner:</strong> Deploy containerized applications from source code with ease and integrate them with various AWS services.</li>
    <li><strong>Hybrid Cloud with AWS Outposts:</strong> Extend AWS services to on-premises locations with AWS Outposts for hybrid cloud scenarios.</li>
    <li><strong>AWS DataSync:</strong> Automate data transfer between on-premises storage and Amazon S3 or Amazon EFS.</li>
    <li><strong>Direct Application Integration:</strong> Utilize SDKs, libraries, and AWS APIs to integrate AWS services into your applications.</li>
    <li><strong>AWS Step Functions:</strong> Orchestrate serverless workflows and coordinate activities across multiple AWS services and external systems.</li>
    <li><strong>Amazon EventBridge:</strong> Create event-driven integrations with AWS services and custom applications using event buses.</li>
    <li><strong>AWS Database Integration:</strong> Connect on-premises databases to AWS using Database Migration Service (DMS) or establish cross-region database replication.</li>
    <li><strong>Amazon Redshift Spectrum:</strong> Query data in Amazon S3 directly from Amazon Redshift to integrate and analyze external data sources.</li>
    <li><strong>Amazon Connect:</strong> Build customer service and contact center integrations with Amazon Connect.</li>
    <li><strong>AWS IoT Core:</strong> Connect devices and integrate IoT data into various AWS services for real-time processing and analysis.</li>
    <li><strong>AWS PrivateLink:</strong> Access AWS services over a private connection, ensuring secure and efficient data transfer.</li>
    <li><strong>AWS Directory Service:</strong> Integrate AWS services with your on-premises Active Directory or use AWS Managed Microsoft AD for directory services.</li>
    <li><strong>Cross-Domain Integration:</strong> Bridge gaps between AWS services from different domains by building custom solutions or using AWS managed services like AWS Step Functions.</li>
    </ul>
    </p>
    </div>
    )
};

export default Integration;
